


import {
    CheckedIcon
} from "components/icons/index";
import React from "react";

const ButtonEvent = ({
    isClickedBtn,
    valueEvent,
    setIsClickedBtn,
    typeEvent
}) => {

    return (
        <button
            className={`${isClickedBtn === valueEvent ? " bg-yellowgray text-white " : " bg-white text-black"}${" flex flex-row justify-between w-1/2 shadow-lg  border-2 border-yellowgray rounded-lg p-3 px-6 py-3 capitalize "}`}
            onClick={() => setIsClickedBtn(valueEvent)}
        >
            {typeEvent}
            {isClickedBtn === valueEvent && <CheckedIcon isClickedBtn={isClickedBtn} />}
        </button>
    )
}

export default ButtonEvent;

